// removed by extract-text-webpack-plugin
module.exports = {"block":"A1HuDWUGqvGQ2OmTeA-KJ","yellow":"_1gCMkAbPEMv2ZvKuyW2MOB","lightgray":"_2o7mrLAohu9xhhuJWGx2p_","text":"_1xJML5rx5DOco6szXNlwkK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TopText/TopText.module.scss
// module id = 811
// module chunks = 0